import React, { useEffect, useState } from "react";
import Button from "../UI/Button";

const GenericPrefillButton = ({
  schemaProps: { text, onClick, countyField, isInlineModal },
  formApi,
}) => {
  const [countyData, setCountyData] = useState({});

  // Address County updates separately
  useEffect(() => {
    if (!!Object.keys(countyData)?.length && !!countyField) {
      formApi.change(
        isInlineModal ? `add_values_field[0][${countyField}]` : countyField,
        countyData
      );
    }
  }, [countyData]);

  return (
    <Button
      onClick={() => {
        const modalValues = onClick(formApi);

        // Address County updates separately
        if (!!countyField) {
          let countyValue =
            isInlineModal && modalValues
              ? modalValues?.[countyField]
              : formApi?.getState()?.values?.[countyField];

          setCountyData(countyValue || {});
        }
      }}
    >
      {text}
    </Button>
  );
};

export default GenericPrefillButton;
